const car_gearbox_types = [
  { key: 1, value: 1, text: "manualna" },
  { key: 2, value: 2, text: "automatyczna" }
];

export default car_gearbox_types; 